import { createSlice } from '@reduxjs/toolkit';
import { buildUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { receiveSubscribeAsync, routerActivationWizardGetStepAsync, routerActivationWizardInitiateAsync, doCallBack , getTimeSlotsAsync, setTimeSlotAsync, getDeliveryAsync, getDeliverySlotsAsync, createDeliveryOrderAsync } from './ServiceAppointmentAsyncthunk';
import { getImageProps } from 'app/utilities/ImageProps';



const initialState = {
    name: 'serviceAppointmentSchedulerBlock',
    page: 'subscribersPage',
    subscriber: {},
    routerDisplay: '',
    typePage: null,
    serviceNumber: '',
    guid: '',
    stepId: '',
    commCode: '',
    phoneNumberForCallBack: '',
    technicianPage:{
        timeSlots:[],
        selectedTechnicianTime:{},
        firstTechnicianTime:{},
        firstTechnicianTimeDisplay:'',
        serviceVisit: {date: '' , time: ''}
    },
    dataEpi:{},
    selectRadio: '',
    delivery: {address: {} , timeSlots: [], selectedDeliveryDate: {}, selectedDeliveryTimeDisplay: ''}
};

const ServiceBlockSlice = createSlice({
    name: 'serviceAppointmentSchedulerBlock',
    initialState: initialState,
    reducers: {
        resetBlock: (state) => initialState,
        initBlock: {
            reducer: (state, action) => {
                state.dataEpi = action.payload.dataEpi;
            },
            prepare(action) {
                let payload = {};
                const serviceAppointmentSchedulerBlock = action.serviceAppointmentSchedulerBlock;
                const context = action.getContext;
                let dataEpi = {
                     blockId: serviceAppointmentSchedulerBlock.contentLink.id,
                     buttonCancelUpdate : serviceAppointmentSchedulerBlock.buttonCancelUpdate.value,
                     buttonRegionalIssue : serviceAppointmentSchedulerBlock.buttonRegionalIssue.value,
                     resetTimeBezeq : serviceAppointmentSchedulerBlock.resetTimeBezeq.value,
                     routerList : serviceAppointmentSchedulerBlock.routerList.expandedValue?.map((item, i) => {
                        return {
                            id: item.id.value,
                            desImage:getImageProps(item.desImage, context),
                            goodBulbsImage: getImageProps( item.goodBulbsImage, context),
                            routerStartTime: item.routerStartTime.value,
                            defaultRouter: item.defaultRouter.value,
                        };
                    }),
                     powerSupplySKU : serviceAppointmentSchedulerBlock.powerSupplySKU.value,
                     routerTimeExtension : serviceAppointmentSchedulerBlock.routerTimeExtension.value,
                     subInfo : serviceAppointmentSchedulerBlock.subInfo.value,
                     subjectCode : serviceAppointmentSchedulerBlock.subjectCode.value,
                     linkConnectionDetails : serviceAppointmentSchedulerBlock.linkConnectionDetails.value,
                     addressIP : serviceAppointmentSchedulerBlock.addressIP.value,
                     user : serviceAppointmentSchedulerBlock.user.value,
                     password : serviceAppointmentSchedulerBlock.password.value,
                     buttonUserPassword : serviceAppointmentSchedulerBlock.buttonUserPassword.value,
                     imageLoader : serviceAppointmentSchedulerBlock.imageLoader.value,
                     lightTime: serviceAppointmentSchedulerBlock.lightTime.value,

                     linkConnectionFailureWifi : serviceAppointmentSchedulerBlock.linkConnectionFailureWifi.value,
                     linkConnectionFailureLine : serviceAppointmentSchedulerBlock.linkConnectionFailureLine.value,
                     linkSlowConnectionWifi : serviceAppointmentSchedulerBlock.linkSlowConnectionWifi.value,
                     linkSlowConnectionLine : serviceAppointmentSchedulerBlock.linkSlowConnectionLine.value,
                     linkConnectionDisconnectionGuidWifi : serviceAppointmentSchedulerBlock.linkConnectionDisconnectionGuidWifi.value,
                     linkConnectionDisconnectionGuidLine : serviceAppointmentSchedulerBlock.linkConnectionDisconnectionGuidLine.value,

                     linkCollectionPoints : serviceAppointmentSchedulerBlock.linkCollectionPoints.value,
                    }
                payload.dataEpi = dataEpi;
                return { payload: payload };
            },
        },
        goToPage: (state, action) => {
            state.page = action.payload.page;
            state.typePage = action.payload.typePage;
            window.scrollTo(0, 0);
        },
        reportDWH: (state, action) => { },
        setSubscriber: (state, action) => {
            state.subscriber = action.payload;
        },
        setSelectRadio : (state, action) => {
            state.selectRadio = action.payload;
        },

        setRouterDisplay: (state, action) => {
            state.routerDisplay = action.payload;
        },
        setErrorPage: (state, action) => {
            state.errorPage = action.payload;
        },
        setPhoneNumberForCallBack: (state, action) => {
            state.phoneNumberForCallBack = action.payload?.replace('-', '');
        },
        setCityAndStreetCode: (state, action) => {
            state.subscriber.address.cityCode = action.payload.cityCode;
            state.subscriber.address.streetCode = action.payload.streetCode;
        },
        setTechnicianSelectedDay: (state, action) => {
            state.technicianPage.timeSlots.map(function (x) {
                if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
                    x.isSelected = true;
                    if (x.hours && x.hours.length > 0) {
                        x.hours[0].isSelected = true;
                    }
                } else {
                    x.isSelected = false;
                }
                return x;
            });

            const selectedTechnicianTime = {
                year: action.payload.year,
                month: action.payload.month,
                day: action.payload.day,
                startDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].startDate : '',
                endDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].endDate : '',
            };
            state.technicianPage.selectedTechnicianTime = selectedTechnicianTime;
            state.technicianPage.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(
                selectedTechnicianTime.startDate,
                selectedTechnicianTime.endDate
            );
        },
        setTechnicianSelectedHours: (state, action) => {
            state.technicianPage.timeSlots.map(function (x) {
                if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
                    x.hours.map(function (hour) {
                        if (hour.startDate == action.payload.startDate) {
                            hour.isSelected = true;
                        } else {
                            hour.isSelected = false;
                        }
                        return hour;
                    });
                }
                return x;
            });
            state.technicianPage.selectedTechnicianTime = action.payload;
            state.technicianPage.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(action.payload.startDate, action.payload.endDate);
        },
        setServiceNumber :  (state, action) => {
            state.serviceNumber = action.payload;
        },
        setDeliveryAddress: (state, action) => {
            state.delivery.address = action.payload;
            state.delivery.address.fullAddress = action.payload.streetName + ' ' + action.payload.home + ', ' + action.payload.cityName;
        },
        setSelectedDeliveryDay: (state, action) => {
          state.delivery.timeSlots.map(function (x) {
            if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
              x.isSelected = true;
              if (x.hours && x.hours.length > 0) {
                x.hours[0].isSelected = true;
              }
            } else {
              x.isSelected = false;
            }
            return x;
          });

          const selectedDeliveryDate = {
            year: action.payload.year,
            month: action.payload.month,
            day: action.payload.day,
            pickLocation: action.payload.pickLocation,
            startDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].startDate : '',
            endDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].endDate : '',
            round: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].round : '',
          };
          state.delivery.selectedDeliveryDate = selectedDeliveryDate;
          state.delivery.selectedDeliveryTimeDisplay = getTechnicianTimeDisplay(selectedDeliveryDate.startDate, selectedDeliveryDate.endDate, true);
        },
        setSelectedDeliveryTime: (state, action) => {
          state.delivery.timeSlots.map(function (x) {
            if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
              x.hours.map(function (hour) {
                if (hour.startDate == action.payload.startDate) {
                  hour.isSelected = true;
                } else {
                  hour.isSelected = false;
                }
                return hour;
              });
            } else {
              x.hours.map(function (hour) {
                hour.isSelected = false;
                return hour;
              });
            }
            return x;
          });
          state.delivery.selectedDeliveryDate = action.payload;
          state.delivery.selectedDeliveryTimeDisplay = getTechnicianTimeDisplay(action.payload.startDate, action.payload.endDate, true);
        },
    },
    extraReducers: {
        [routerActivationWizardGetStepAsync.fulfilled]: (state, action) => {
            if (!action.payload) { return; }
            state.serviceNumber = action.payload.outputCode;
            state.stepId = action.payload.stepId;
            state.commCode = action.payload.commCode;

        },
        [routerActivationWizardInitiateAsync.fulfilled]: (state, action) => {
            if (!action.payload) { return; }
            state.guid = action.payload.requestId;
            state.stepId = action.payload.stepId;
            state.commCode = action.payload.commCode;
        },
        [doCallBack.fulfilled]: (state, action) => {
        },
        [getTimeSlotsAsync.fulfilled]: (state, action) => {
            if (!action.payload) { return; }

            let technicianTimes = getCustomTechnicianTimes(action.payload.listSlots);
            if (technicianTimes?.length > 0) {
                technicianTimes[0].isSelected = true;
                if (technicianTimes[0].hours?.length > 0) {
                    technicianTimes[0].hours[0].isSelected = true;
                }

                const firstTechnicianTime = {
                    startDate: technicianTimes[0].hours[0].startDate,
                    endDate: technicianTimes[0].hours[0].endDate,
                };

                state.technicianPage.firstTechnicianTime = firstTechnicianTime;
                state.technicianPage.selectedTechnicianTime = firstTechnicianTime;
                state.technicianPage.firstTechnicianTimeDisplay = getTechnicianTimeDisplay(firstTechnicianTime.startDate,firstTechnicianTime.endDate);
                state.technicianPage.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(firstTechnicianTime.startDate,firstTechnicianTime.endDate);
            }
            if(action.payload.hasServiceVisit){
                const serviceVisit =  action.payload.serviceVisit.split(' ');
                const date = serviceVisit[0];
                const time = serviceVisit[1];
                state.technicianPage.serviceVisit = {date: date, time: time}
            }
            state.technicianPage.timeSlots = technicianTimes;
        },
        [setTimeSlotAsync.fulfilled]: (state, action) => {
            if (!action.payload) { return; }
            state.technicianPage.isTimeSlotOccupied = !(action.payload.isSuccess);
        },
        [getDeliveryAsync.fulfilled]: (state, action) => {
            if(!action.payload || !action.payload.item || action.payload.item.length === 0){ return; }
            const delivery = action.payload.item[0];
            state.delivery = delivery;
            state.delivery.fullAddress = delivery.Street + ' ' + delivery.HouseNumber + ', ' + delivery.City;
        },
        [getDeliverySlotsAsync.fulfilled]: (state, action) => {
          if (!action.payload) { return; }
          let timeSlots = deliveryTimeSlotsFormat(action.payload);
          if (timeSlots?.length > 0) {
            timeSlots[0].isSelected = true;
            state.delivery.selectedDeliveryDate = {year: timeSlots[0].year, month: timeSlots[0].month, day: timeSlots[0].day, pickLocation: timeSlots[0].pickLocation};
            if (timeSlots[0].hours?.length > 0) {
              timeSlots[0].hours[0].isSelected = true;
              state.delivery.selectedDeliveryDate.startDate = timeSlots[0].hours[0].startDate;
              state.delivery.selectedDeliveryDate.endDate = timeSlots[0].hours[0].endDate;
              state.delivery.selectedDeliveryDate.round = timeSlots[0].hours[0].round;
              state.delivery.selectedDeliveryTimeDisplay = getTechnicianTimeDisplay(
                timeSlots[0].hours[0].startDate,
                timeSlots[0].hours[0].endDate,
                true
              );
            }
          }
          state.delivery.timeSlots = timeSlots;
        }
    },
});


export const {
    reportDWH,
    goToPage,
    initBlock,
    resetBlock,
    setSubscriber,
    setInerrantTestType,
    setMessagePage,
    setRouterDisplay,
    setTechnicianSelectedDay,
    setTechnicianSelectedHours,
    setCityAndStreetCode,
    setCommunicationResetType,
    setRestartRouter,
    setServiceNumber,
    setSelectRadio,
    setErrorPage,
    setPhoneNumberForCallBack,
    setDeliveryAddress,
    setSelectedDeliveryDay,

    setSelectedDeliveryTime
} = ServiceBlockSlice.actions;

export default ServiceBlockSlice.reducer;



function getCustomTechnicianTimes(technicianTimesList) {
    if (!technicianTimesList) {
        return;
    }

    const groups = technicianTimesList.reduce((groups, item) => {
        const date = item.start.split('T')[0];
        if (!groups[date]) {
            groups[date] = [];
        }
        groups[date].push(item);
        return groups;
    }, {});

    const groupArrays = Object.keys(groups).map((date) => {
        return {
            date,
            hours: groups[date],
        };
    });

    let technicianTimes = [];

    groupArrays.forEach((item) => {
        let currentDate = new Date(item.date);
        let year = currentDate.getFullYear();
        let month = currentDate.getMonth() + 1;
        let monthName = getMonthName(currentDate.getMonth());
        let day = currentDate.getDate();
        let dayOfWeek = getDayOfWeek(currentDate.getDay());
        let hours = [];

        item.hours.forEach((hour) => {
            let startDate = new Date(hour.start);
            let endDate = new Date(hour.end);

            const hourItem = {
                startDate: hour.start,
                endDate: hour.end,
                start: ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2),
                end: ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2),
                isSelected: false,
            };

            hours.push(hourItem);
        });

        let technicianTime = {
            year: year,
            month: month,
            monthName: monthName,
            day: day,
            dayOfWeek: dayOfWeek,
            hours: hours,
            isSelected: false,
        };

        technicianTimes.push(technicianTime);
    });

    return technicianTimes;
}

function getMonthName(month) {
    const monthNames = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
    return monthNames[month];
}

function getDayOfWeek(dayOfWeek) {
    const weekDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
    return weekDays[dayOfWeek];
}

function getTechnicianTimeDisplay(start, end , isDelivery) {
    let startDate = new Date(start);
    let endDate = new Date(end);

    const dayOfWeek = getDayOfWeek(startDate.getDay());
    const dateToDisplay = formatDate(startDate);

    const startHour = ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2);
    const endHour = ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2);

    let selectedTechnicianTimeDisplay = `${dayOfWeek},\n${dateToDisplay} בין השעות ${startHour}-${endHour}`;
    if(isDelivery){
        selectedTechnicianTimeDisplay = `${dayOfWeek} ${dateToDisplay}\n בין ${startHour}-${endHour}`;
    }

    return selectedTechnicianTimeDisplay;
}

function formatDate(date) {
    const yy = date.getFullYear().toString().slice(-2);
    let mm = date.getMonth() + 1;
    let dd = date.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const dateToDisplay = dd + '.' + mm + '.' + yy;
    return dateToDisplay;
}

function deliveryTimeSlotsFormat(timeSlots) {
  if (!timeSlots) {
    return;
  }

  const groupsByDate = timeSlots.reduce((groups, item) => {
    const date = item.lfdat;
    if (!groups[date]) {
      groups[date] = {date: date, pickLocation: item.pickLocation, hours: []};
    }
    groups[date].hours.push({start: item.waitFrom, end: item.waitTo, round: item.round});
    return groups;
  }, []);

  let timeSlotsRes = [];

  Object.keys(groupsByDate).map((key) => {
    const item = groupsByDate[key];
    let currentDate = new Date(item.date);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let monthName = getMonthName(currentDate.getMonth());
    let day = currentDate.getDate();
    let dayOfWeek = getDayOfWeek(currentDate.getDay());
    let pickLocation = item.pickLocation;
    let hours = [];

    item.hours.forEach((hour) => {
      const hourItem = {
        startDate: item.date + 'T' + hour.start,
        endDate: item.date + 'T' + hour.end,
        round: hour.round,
        start: hour.start.slice(0, 5),
        end: hour.end.slice(0, 5),
        isSelected: false,
      };

      hours.push(hourItem);
    });

    let deliveryTime = {
      year: year,
      month: month,
      monthName: monthName,
      day: day,
      dayOfWeek: dayOfWeek,
      pickLocation: pickLocation,
      hours: hours,
      isSelected: false,
    };

    timeSlotsRes.push(deliveryTime);
  });

  return timeSlotsRes;
}
